import Container from './StudioUploadsList.container';
import StudioUploadsList from './StudioUploadsList';

export default Container(StudioUploadsList);
